import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import SEO from "../../components/SEO";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    api.get("/auth/me")
      .then(() => navigate("/admin", { replace: true }))
      .catch(() => setChecking(false));
  }, [navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#060A12] flex items-center justify-center px-5 rk-grain relative">
      <SEO title="Administration" />
      <div className="w-full max-w-md border border-[#C5A059]/25 bg-[#0B1320] p-10 sm:p-14 text-center">
        <p className="font-serif text-3xl text-[#FBF9F5]">
          RK <span className="text-[#C5A059] italic">Group</span>
        </p>
        <p className="text-[10px] uppercase tracking-[0.3em] text-[#94A3B8] mt-3 font-semibold">Administration Panel</p>
        <p className="text-sm text-[#94A3B8] leading-relaxed mt-6">
          Sign in with your authorised Google account. The first account to sign in becomes the Super
          Administrator; subsequent accounts require role assignment.
        </p>
        <button
          data-testid="admin-google-login-btn"
          onClick={login}
          disabled={checking}
          className="mt-10 w-full text-[11px] uppercase tracking-[0.22em] font-semibold bg-[#C5A059] text-[#060A12] px-8 py-4 hover:bg-[#d6b678] transition-colors duration-300 disabled:opacity-50"
        >
          {checking ? "Checking session…" : "Sign in with Google"}
        </button>
      </div>
    </div>
  );
}
